import Main from "./components/Main.js";
import Routing from "./routing/Routing";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function App() {
  const { pathname } = useLocation();

  const userAuth = useSelector((state) => state.auth.userAuth);

  return (
    <div
      className={`max-w-screen-2xl mx-auto pr-3 ${
        pathname === "/login" && "bg-[#fff]"
      }`}
    >
      {/* create routes in routing and sending through main as a children */}

      <Main userAuth={userAuth}>
        <Routing userAuth={userAuth} />
      </Main>
    </div>
  );
}

export default App;
